/** Web app version stamped by CI (VITE_APP_VERSION); "dev" for local builds. */
export function webVersion(): string {
  const v: unknown = import.meta.env.VITE_APP_VERSION;
  return typeof v === 'string' && v !== '' ? v : 'dev';
}
